import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";

// import { useParams } from "react-router-dom";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import { formatCurrency } from "../../common/format-currency";
import RenderItem from "../../common/renderItem";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "react-loader-spinner";
import ContentLoader from "react-content-loader";
import { isMobile } from "react-device-detect";
import { SpinnerCircular } from "spinners-react";
import ProgressBar from "@ramonak/react-progress-bar";

import { useMediaQuery } from "react-responsive";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setAllCategories,
} from "../../redux/actions/postActions";
import {
  KMTracking,
  campaignRecord,
} from "../../components/Tracking/KMTracking";
import ScrollAnimation from "react-animate-on-scroll";
import cleanURL from "../../common/cleanURL";
import "animate.css/animate.compat.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
// import { ClipLoader } from "react-spinners";

let divSet = true;
const MyLoader = () => (
  <ContentLoader viewBox="0 0 1000 400">
    <rect x="3" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="350" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="700" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="3" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="350" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="700" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="3" y="330" rx="4" ry="4" width="175" height="28" />
    <rect x="3" y="371" rx="4" ry="4" width="131" height="33" />
    <rect x="350" y="330" rx="4" ry="4" width="300" height="29" />
    <rect x="350" y="371" rx="4" ry="4" width="116" height="30" />
    <rect x="700" y="330" rx="4" ry="4" width="173" height="29" />
    <rect x="700" y="371" rx="4" ry="4" width="200" height="31" />
  </ContentLoader>
);

function Category(props) {
  const [category, setCategory] = useState<any>([]);
  const [cat_ID, setCat_ID] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState<any>("");
  const [parentCategory, setParentCategory] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [divWidth, setDivWidth] = useState(0);
  const [categories, setCategories] = useState([]);
  const [sideDrawerVisible, setSideDrawerVisible] = useState(false);
  const [productCount, setProductCount] = useState(0);
  const [moreProductsAvailable, setMoreProductsAvailable] = useState(true);
  const [parentPath, setParentPath] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [is_loading, setIsLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [allProductLength, setAllProductLength] = useState<any>(0);
  const [DeliveryID,setDeliveryID]= useState("")

  const sortOptions = [
    { id: 1, label: "Name", value: "name" },
    { id: 2, label: "Latest", value: "-created" },
    { id: 3, label: "Price Low to High", value: "price" },
    { id: 4, label: "Price High to Low", value: "-price" },
  ];

  const categoryBlurbs = [
    {
      id: "c9fe3927-68bb-49af-8042-62d545f513df",
      label: "WOMEN",
      blurb: "Revamp your wardrobe with the latest styles and fashion gems.",
    },
    {
      id: "165fdee1-e0cb-4d07-8409-cae9f20c98bb",
      label: "MEN",
      blurb:
        "Discover easy-to-wear clothing from everyday staples to versatile workwear.",
    },
    {
      id: "cafe862a-dcb1-45ac-a7e3-ff13b91ff2c1",
      label: "KIDS",
      blurb:
        "Explore fashion and accessories for your little ones’ next adventure.",
    },
    {
      id: "7f26ef5f-b8b3-4b50-a4a6-76055ddc29cf",
      label: "ACCESSORIES",
      blurb:
        "Finish your look with our range of bags, sunglasses, jewelry and more.",
    },
    {
      id: "3008f732-d32c-4973-8f56-2b2db824458e",
      label: "HOME",
      blurb:
        "Bring your home to life with furnishings, home fragrances, storage solutions and more.",
    },
    {
      id: "914ef91e-6cd2-4363-bcb4-e61599b57ba0",
      label: "TECH",
      blurb:
        "Shop our range of electronics including cameras, mobile phones, chargers, and more.",
    },
    {
      id: "8b9e896f-2f1a-4780-80e5-411f85c618db",
      label: "WELLNESS",
      blurb:
        "From skincare to supplements, achieve a healthy glow with our beauty and wellness collection.",
    },
    {
      id: "8cd1d5a1-b9ed-4cf8-91be-46356e9e7043",
      label: "LIFESTYLE",
      blurb:
        "Find the perfect gift or new hobby with a range of books, toys, arts & crafts, and more",
    },
    {
      id: "c3496699-60c0-40b8-b94f-c6897c69b8df",
      label: "PANTRY",
      blurb:
        "Celebrate any occasion with must-have pantry additions, such as wines, spirits and more.",
    },
    {
      id: "6770241a-bbc8-4fb1-99ee-8e57b12618b8",
      label: "Care for Your Skin",
      blurb:
        "Achieve younger, brighter, clearer-looking skin with next-generation skincare products.",
    },
    {
      id: "260f5201-9717-4613-ba35-d49b89783e18",
      label: "Books of the Month",
      blurb:
        "Kick back, relax and immerse in the exotic worlds of these leisure reads.",
    },
  ];

  const isMobileOnly = useMediaQuery({ maxWidth: "765px" });
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const [sortBy, setSortBy] = useState<any>(sortOptions[0]);
  // let { name, ID } = useParams();
  useEffect(() => {
    let ACFData:any = localStorage.getItem("ACF")
    let Deliveryid =JSON.parse(ACFData)?.FrasersDeliveryItemID
    setDeliveryID(Deliveryid)
    props.location.search &&
      campaignRecord(props.location.search, props.location.pathname);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      setActiveIndex(null);
      setSortBy(sortOptions[0]);
    };
  }, [props.match.params.name]);
  useEffect(() => {
    let name = props.match.params.name;
    let ID = props.match.params.ID;

    setIsLoading(true);
    setProducts([]);
    getCategories(cleanURL(name), ID); //.replace(/-/g, " ")
    // setActiveIndex(null);
    // if(_.isEmpty(category)){
    //     setIsLoading(false)
    // }
  }, [props.match.params.name, sortBy, selectedCategory]);
  useEffect(() => {
    let _soldOut: any = [];
    let _tempArray: any = [];
    const path = props?.location?.pathname;
    const path1 = path?.split("/");

    if (path1?.length == 4) {
      setParentPath(path1[3]);
    } else if (path1?.length == 3) {
      setParentPath(path1[2]);
    } else if (path1?.length == 2) {
      setParentPath(path1[1]);
    }
    products.map((item, index) => {
      let isSale =
        item.AddOns && item.AddOns.length > 0
          ? item.OriginalPrice
            ? true
            : false
          : item.StockLimited
          ? item.StockQuantity > 0
            ? item.OriginalPrice
              ? true
              : false
            : true
          : false;
      //sorting removed for sold out products at last
      // if (isSale || item.StockQuantity == 0 || item.StockQuantity == null) {
      //   _soldOut = [..._soldOut, item];
      // } else {
      _tempArray = [..._tempArray, item];
      // }
    });
    var newArr = _tempArray.concat(_soldOut);
    setSortedProducts(newArr);
  }, [products, activeIndex]);
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const getCategories = async (name: any, ID: any) => {
    let category_name:any = ""
    setPageNumber(1);
    if (name.includes("featured")) {
      name = "Featured Products";
    }
    if (props?.allCategories.length > 0) {
      let tempCategories: any = [];
      props?.allCategories.map((item) => {
        if (item?.Description !== "hidden") {
          tempCategories = [...tempCategories, item];
        }
      });
      setCategories(tempCategories);
      // setCategories(response)
      props?.allCategories?.map((item: any, index) => {
        if (item.ChildCategories.length > 0) {
          item?.ChildCategories?.map((item2: any, i) => {
            if (item2?.ID == ID) {
              category_name = item2.Name
              setCategory(item2);
              setActiveIndex(i);
              getProducts(1, item2.ID);
              setTotalCountForDelivery(item2.ID)
              console.log();
              if (item2.ParentCategoryID !== null) {
                getParentCategoryName(item2.ParentCategoryID);
              }
              return;
            }
            if (item?.ID == ID) {
              category_name = item.Name
              setCategory(item);
              getProducts(1, item.ID);
              setTotalCountForDelivery(item.ID)
              if (item.ParentCategoryID !== null) {
                getParentCategoryName(item.ParentCategoryID);
              } else {
                setParentCategory(item);
              }
            }
          });
        } else {
          if (item?.ID == ID) {
            category_name = item.Name
            setCategory(item);
            getProducts(1, item.ID);
            setTotalCountForDelivery(item.ID)
            if (item.ParentCategoryID !== null) {
              getParentCategoryName(item.ParentCategoryID);
            } else {
              setParentCategory(item);
            }
          }
        }
      });
      props?.allCategories?.map((item: any) => {
        if (item.ID == ID) {
          setCat_ID(item?.ID);
        } else if (item?.ChildCategories.length > 0) {
          item?.ChildCategories?.map((item2) => {
            if (item2.ID == ID) {
              setCat_ID(item2?.ID);
            }
          });
        }
      });
      const updated_category_name = category_name?.replace(/[, ]/g, '_');
      const data = { "Category_Name": updated_category_name };
      tracker("viewedcategory", data);
      setSelectedCategory(category.Name);
    } else {
      await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
        if (response) {
          props.setAllCategories(response);
          let tempCategories: any = [];
          response.map((item) => {
            if (item?.Description !== "hidden") {
              tempCategories = [...tempCategories, item];
            }
          });
          setCategories(tempCategories);
          // setCategories(response)
          response?.map((item: any, index) => {
            if (item.ChildCategories.length > 0) {
              item?.ChildCategories?.map((item2, i) => {
                if (item2?.ID == ID) {
                  category_name = item2.Name
                  setCategory(item2);
                  setActiveIndex(i);
                  getProducts(1, item2.ID);
                  if (item2.ParentCategoryID !== null) {
                    getParentCategoryName(item2.ParentCategoryID);
                  }
                  return;
                }
                if (item?.ID == ID) {
                  category_name = item.Name
                  setCategory(item);
                  getProducts(1, item.ID);
                  if (item.ParentCategoryID !== null) {
                    getParentCategoryName(item.ParentCategoryID);
                  } else {
                    setParentCategory(item);
                  }
                }
              });
            } else {
              if (item?.ID == ID) {
                category_name = item.Name
                setCategory(item);
                getProducts(1, item.ID);
                if (item.ParentCategoryID !== null) {
                  getParentCategoryName(item.ParentCategoryID);
                } else {
                  setParentCategory(item);
                }
              }
            }
          });
          response?.map((item: any) => {
            if (item.ID == ID) {
              setCat_ID(item?.ID);
            } else if (item?.ChildCategories.length > 0) {
              item?.ChildCategories?.map((item2) => {
                if (item2.ID == ID) {
                  setCat_ID(item2?.ID);
                }
              });
            }
          });
          const updated_category_name = category_name.replace(/[, ]/g, '_');
          const data = { "Category_Name": updated_category_name };
          tracker("viewedcategory", data);
          setSelectedCategory(category.Name);
        }
      });
    }
  };
  const getParentCategoryName = async (parentID) => {
    if (props?.allCategories.length > 0) {
      props?.allCategories?.map((item: any) => {
        if (item?.ID == parentID) {
          setParentCategory(item);
        }
      });
    } else {
      await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
        if (response) {
          props.setAllCategories(response);
          response?.map((item: any) => {
            if (item?.ID == parentID) {
              setParentCategory(item);
            }
          });
        }
      });
    }
  };
  const getProducts = async (pageNumber: number, cat_id: number) => {
    let _products: any = [];
    let itemObj = {
      Categories: [cat_id],
      pageSize: 20,
      Sort: sortBy?.value ? sortBy.value : "name",
      pageNumber: pageNumber ? pageNumber : 1,
    };
    await new WebApiCalls().getItemsByFilters(itemObj).then((response) => {
        setLoader(false);
      if (response?.Records?.length > 0) {
        setProductCount(response?.Records?.length);
        response?.Records?.map((item) => {
          if (
            item?.ID == DeliveryID
          ) {
            return;
          } else {
            if (item) {
              _products = [..._products, item];
            }
          }
        });
        if (pageNumber == 1) {
          console.log("Products here: ", _products);
          // setProducts(_.uniqBy(_products, "ID"));
          setProducts(_products);
          setIsLoading(false);
        } else {
          setProducts(products.concat(_products));
          setIsLoading(false);
        }
      } else {
        setMoreProductsAvailable(false);
        setIsLoading(false);
      }
    });
  };
  const setTotalCountForDelivery=(categoryID)=>{
    let body={
      Categories: [categoryID],
      pageSize: -1,
    }
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
  fetch(`${process.env.REACT_APP_FRX_API_URL}/estore/api/v2/items/`,request).then((resp)=>{
   return resp.json()
  }).then((response)=>{
   let isDelivery = response?.Records?.some((item)=>{
   return item.ID == DeliveryID
  })
  if(isDelivery){
    setAllProductLength(response.TotalRecords-1);
  }else{
    setAllProductLength(response.TotalRecords);
  }
  })
  }
  const onClickItem = (_item) => {
    // if (_item.Name.includes('/')) {
    //     props?.history?.push(`/product/${(_item.Name).replace(/\\|\//g, '-')}/${_item.ID}`, { cat1: `${parentCategory?.Name ? parentCategory?.Name : category?.Name}`, cat2: `${parentCategory?.Name ? category?.Name : (props?.location?.state?.cat2 ? props?.location?.state?.cat2 : "")}`, path: `/product/${(_item.Name).replace(/\\|\//g, '-')}/${_item.ID}` })
    // }
    // else {
    //     props?.history?.push(`/product/${_item.Name}/${_item.ID}`, { cat1: `${parentCategory?.Name ? parentCategory?.Name : category?.Name}`, cat2: `${parentCategory?.Name ? category?.Name : (props?.location?.state?.cat2 ? props?.location?.state?.cat2 : "")}`, path: `/product/${_item.Name}/${_item.ID}` })

    // }
    // console.log("I am clicked now....")

    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "Category",
    });
  };
  //mainreturn
  let selectedBlurb = "";
  categoryBlurbs.forEach((cat) => {
    if (
      cat.label?.toLowerCase() === parentCategory?.Name?.toLowerCase() ||
      cat.id === parentCategory?.ID
    ) {
      selectedBlurb = cat.blurb;
    }
  });
  return (
    <div>
      <Helmet>
        <meta
          property="og:title"
          content={parentCategory?.Name}
          data-rh="true"
        />
        <meta
          property="og:description"
          content={selectedBlurb}
          data-rh="true"
        />
        <meta
          property="og:image"
          content={
            category?.Media?.length > 0
              ? category?.Media[0]?.MediaUrl
              : parentCategory?.Media?.length > 0
              ? parentCategory?.Media[0]?.MediaUrl
              : ""
          }
          data-rh="true"
        ></meta>
      </Helmet>
      <div className="viewport"></div>
      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}
        <div
          className={`main-overlay ${sideDrawerVisible ? "active" : ""}`}
          onClick={() => {
            setSideDrawerVisible(!sideDrawerVisible);
          }}
        ></div>

        {/* mainmenu */}
        <MenuBar props={props} />
        {/* /mainmenu */}

        {/* /content */}
        <div className="content">
          {/* breadcrumb */}
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            {category?.ParentCategoryID ? (
              <>
                <Link
                  to={`/category/${cleanURL(parentCategory?.Name)}/${
                    parentCategory.ID
                  }`}
                >
                  {parentCategory.Name}
                </Link>
                <a href="">{category?.Name}</a>
              </>
            ) : (
              <>
                <Link
                  to={`/category/${cleanURL(category?.Name)}/${category?.ID}`}
                >
                  {category?.Name}
                </Link>
                {props?.location?.state?.cat2 && (
                  <a href="">{props?.location?.state?.cat2}</a>
                )}
              </>
            )}
          </div>
          {/* /breadcrumb */}

          {/* category hero */}
          <div className="category-hero">
            <div className="thumb">
              <div className="overlay"></div>
              <img
                src={
                  category?.Media?.length > 0
                    ? category?.Media[0]?.MediaUrl
                    : parentCategory?.Media?.length > 0
                    ? parentCategory?.Media[0]?.MediaUrl
                    : ""
                }
                alt=""
              />
            </div>
            <div className="text">
              <div className="title">{parentCategory?.Name}</div>
              {/*here I started the work...  */}
              {!isMobileOnly &&
                categoryBlurbs.map(
                  (cat, index) => {
                    if (
                      cat.label?.toLowerCase() ===
                        parentCategory?.Name?.toLowerCase() ||
                      cat.id === parentCategory?.ID
                    ) {
                      return (
                        <div
                          key={index}
                          style={
                            isMobileOnly
                              ? { color: "#fff", fontSize: 14 }
                              : { color: "#666", fontSize: 14 }
                          }
                        >
                          {cat.blurb}
                        </div>
                      );
                    }
                  }

                  // <div style={{ color: "#666", fontSize: 14 }}>
                  //   Shop our range of electronics, computing, mobiles & more
                  // </div>
                )}
            </div>
          </div>
          {/* /category hero */}

          {/* product listing */}
          <div className="product-listing" style={{ marginBottom: "2px" }}>
            {/* sub-categories (mobile) */}
            {/* <div
              className="sub-categories mobile-only"
              onClick={() => {
                // setSideDrawerVisible(true);
              }}
            > 
             <div className="title">CATEGORY</div> 
             <div>{_.capitalize(selectedCategory)}</div> 
             <select
                name="sub-categories"
                id="sub-categories"
                defaultValue={_.capitalize(selectedCategory)}
              >
            <option value="">{_.capitalize(selectedCategory)}</option>
            <option value="">Computing & Accessories</option>
                                <option value="">Phones & Accessories</option>
                                <option value="">Wearables & Smart Home</option>
                                <option value="">TV & Projector</option>
                                <option value="">Home Appliances</option>
                                <option value="">Headphones, Speakers & Audio</option>
                                <option value="">Camera & Drones</option> 
            </select>
            </div> */}

            {/* /sub-categories (mobile) */}

            {/* slide-categories */}
            {/* {sideDrawerVisible && */}
            <div
              className={`slide-categories ${
                sideDrawerVisible ? "active" : ""
              }`}
            >
              <div className="title">CATEGORIES</div>

              <dl className="accordion show">
                {categories?.map((item: any, index) => {
                  return (
                    <>
                      <dt className="active" key={index}>
                        <Link
                          to={`/category/${cleanURL(item.Name)}/${item.ID}`}
                          onClick={() => {
                            props?.history?.push(
                              `/category/${cleanURL(item.Name)}/${item.ID}`
                            );
                            setSideDrawerVisible(false);
                            const category_name = item.Name;
                            const updated_category_name = category_name.replace(/[, ]/g, '_');
                            const data = { "Category_Name": updated_category_name };
                            tracker("viewedcategory", data);
                            setSelectedCategory(item.Name);
                          }}
                        >
                          {_.capitalize(item?.Name)}
                        </Link>
                      </dt>
                      {item?.ChildItems?.map((item2, index2) => {
                        return (
                          <>
                            <dd key={index2}>
                              <a>{item2.Name}</a>
                            </dd>
                          </>
                        );
                      })}
                    </>
                  );
                })}
              </dl>
            </div>
            {/* } */}
            {/* /slide-categories */}

            {/* filter */}
            <div className="filter" style={{ width: "100%" }}>
              <div className="text">Sort by</div>
              <select
                value={sortBy.value}
                name="sortby"
                id="sortby"
                onChange={(e: any) => {
                  setPageNumber(1);
                  let selecteOption = sortOptions.find(
                    (option) => option.value == e.target.value
                  );
                  setSortBy(selecteOption);
                  let kmFilterValuesProps = {
                    "Filter Type": "SORT BY",
                    "Sort Value": selecteOption,
                  };
                  tracker("appliedfilter", kmFilterValuesProps);
                }}
              >
                {sortOptions?.map((item: any, index) => {
                  return (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* /filter */}

            {/* slide-categories */}
            <div className="slide-sortby">
              <div className="title">SORT BY</div>
              <a>Name</a>
              <a>Latest</a>
              <a>Price (High)</a>
              <a>Price (Low)</a>
            </div>
            {/* /slide-categories */}

            {/* two-columns */}
            <div className="two-columns">
              {/* categories (desktop) */}

              {!isTabletOrMobileDevice && (
                <div className="sub-categories">
                  {parentCategory?.Name ? (
                    <div className="title">
                      <Link
                        className={
                          activeIndex == null
                            ? "active"
                            : parentPath == parentCategory?.Name
                            ? "active"
                            : ""
                        }
                        to={`/category/${cleanURL(parentCategory.Name)}/${
                          parentCategory?.ID
                        }`}
                        onClick={() => {
                          setProducts([]);
                          setSortedProducts([]);
                          props?.history?.replace(
                            `/category/${cleanURL(parentCategory.Name)}/${
                              parentCategory?.ID
                            }`
                          );
                          getProducts(1, cat_ID);
                          setActiveIndex(null);
                        }}
                      >
                        {"All " + `${parentCategory?.Name}`}
                      </Link>
                    </div>
                  ) : (
                    category?.Name && (
                      <div className="title">
                        <Link
                          to={`/category/${cleanURL(category.Name)}/${
                            category?.ID
                          }`}
                          className={activeIndex == null ? "active" : ""}
                          onClick={() => {
                            setProducts([]);
                            setSortedProducts([]);
                            props?.history?.replace(
                              `/category/${cleanURL(category.Name)}/${
                                category?.ID
                              }` //replace(/ /g, "-")
                            );
                            getProducts(1, cat_ID);
                            setActiveIndex(null);
                          }}
                        >
                          {"All " + `${category?.Name}`}
                        </Link>
                      </div>
                    )
                  )}
                  {category?.ChildCategories?.length > 0
                    ? category?.ChildCategories?.map((item: any, index) => {
                        let activeCategory = "";
                        if (parentPath == item?.Name) {
                          activeCategory = "active";
                        }
                        return (
                          <Link
                            to={`/category/${cleanURL(item.Name)}/${item?.ID}`}
                            key={index}
                            className={index === activeIndex ? "active" : ""} //activeCategory changed to '' for double category highlight on filter select issue
                            onClick={() => {
                              setProducts([]);
                              setSortedProducts([]);
                              // props?.history?.replace(`/category/${category.Name}/${item.Name}`, { cat1: `${category?.Name ? category?.Name : item?.Name}`, cat2: `${category?.Name ? item?.Name : ""}` })
                              props?.history?.replace(
                                `/category/${cleanURL(item.Name)}/${item?.ID}`, //.replace(/ /g, "-")
                                {
                                  cat1: `${
                                    category?.Name ? category?.Name : item?.Name
                                  }`,
                                  cat2: `${category?.Name ? item?.Name : ""}`,
                                }
                              );
                              getProducts(1, item.ID);
                              setActiveIndex(index);
                            }}
                          >
                            {item?.Name}
                          </Link>
                        );
                      })
                    : parentCategory?.ChildCategories?.map(
                        (item: any, index) => {
                          let activeCategory = "";
                          if (parentPath == item?.Name) {
                            activeCategory = "active";
                          }
                          return (
                            <Link
                              key={index}
                              className={
                                index === activeIndex
                                  ? "active"
                                  : activeCategory
                              }
                              to={`/category/${cleanURL(item.Name)}/${
                                item?.ID
                              }`}
                              onClick={() => {
                                setProducts([]);
                                setSortedProducts([]);
                                // props?.history?.replace(`/category/${category.Name}/${item.Name}`, { cat1: `${category?.Name ? category?.Name : item?.Name}`, cat2: `${category?.Name ? item?.Name : ""}` })
                                props?.history?.replace(
                                  `/category/${cleanURL(item.Name)}/${
                                    item?.ID
                                  }`, //.replace(/ /g, "-")
                                  {
                                    cat1: `${
                                      category?.Name
                                        ? category?.Name
                                        : item?.Name
                                    }`,
                                    cat2: `${category?.Name ? item?.Name : ""}`,
                                  }
                                );
                                getProducts(1, item.ID);
                                setActiveIndex(index);
                              }}
                            >
                              {item?.Name}
                            </Link>
                          );
                        }
                      )}
                </div>
              )}
              <div className="product-listing" style={{ width: "100%" }}>
                {/* <ScrollAnimation animateIn='bounceInLeft'> */}

                <div>
                  {is_loading ? (
                    <MyLoader />
                  ) : (
                    <>
                      {sortedProducts.length > 0 ? (
                        <div className="products" style={{ width: "100%" }}>
                          {sortedProducts?.map((item: any, index: number) => {
                            return (
                              <RenderItem
                                key={index}
                                is_slider={false}
                                item={item}
                                from={"Category"}
                                onClickItem={onClickItem}
                              />
                            );
                          })}
                          <i aria-hidden={true}></i>
                          <i aria-hidden={true}></i>
                        </div>
                      ) : (
                        <div className="products">
                          <br />
                          There are currently no products in this category.
                          <br />
                          Please check again later.
                        </div>
                      )}
                      <></>
                      {products.length > 0 && (
                        <>
                          <div
                            style={{ textAlign: "center" }}
                            className="load-more-sec"
                          >
                            <div
                              style={{
                                fontFamily: "Montserrat",
                                fontSize: "11px",
                                lineHeight: "20px",
                                color: "#666",
                              }}
                            >
                              {`You've viewed ${products.length} of ${allProductLength}
                          products`}
                            </div>
                            <ProgressBar
                              className="progress-bar category-progress-bar"
                              isLabelVisible={false}
                              maxCompleted={parseInt(allProductLength)}
                              completed={products.length}
                              height="2px"
                              width="100%"
                              bgColor="#000000"
                            />
                          </div>
                          {allProductLength !== products.length && (
                            <div style={{ textAlign: "center" }}>
                              {!loader ? (
                                <button
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                    backgroundColor: "#ffffff",
                                    color: "#000000",
                                    padding: "10px 60px",
                                    border: "1px solid #DDDDDD",
                                    cursor: "pointer",
                                    letterSpacing: "1.5px",
                                    fontWeight: 500,
                                  }}
                                  onClick={() => {
                                    let page = pageNumber + 1;
                                    setPageNumber(page);
                                    if (cat_ID !== 0) {
                                      getProducts(page, cat_ID);
                                      setLoader(true);
                                    }
                                  }}
                                  className="btn"
                                >
                                  LOAD MORE
                                </button>
                              ) : (
                                <SpinnerCircular
                                  color="black"
                                  size="33"
                                  thickness={170}
                                  speed={200}
                                />
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                {/* </ScrollAnimation> */}
              </div>
            </div>
          </div>
          {/* /product listing */}
        </div>
        {/* /content*/}
      </div>
      {/* /container */}

      {/* footer */}
      <Footer categoriesArray={categories ? categories : ""} props={props} />
      {/* /footer */}
      <a onClick={() => window.scrollTo(0, 0)} className="btt">
        <img src="images/uparrow.svg" alt="" />
      </a>
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, allCategories } = state.UserReducer;
  return { cart_count, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setAllCategories,
};
export default connect(mapStateToProps, actions)(Category);
